import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { LanguageToggle } from '../components/ui/LanguageToggle';
export function Terms() {
  const {
    lang
  } = useLanguage();
  const content = lang === 'es' ? <>
        <h1 data-id="element-663" data-mp="79fxs13qlh39">Términos de Servicio</h1>
        <p className="muted" data-id="element-664" data-mp="7ahjr0majnzr">Última actualización: 11 de julio de 2026</p>

        <h2 data-id="element-665" data-mp="c8sr94p45met">1. Aceptación de los términos</h2>
        <p data-id="element-666" data-mp="c7zijy6lgmu1">
          Al acceder y utilizar este Sitio, usted acepta estos Términos de
          Servicio. Si no está de acuerdo con ellos, no utilice el Sitio.
        </p>

        <h2 data-id="element-667" data-mp="la8tgp5ryi7y">2. Naturaleza del sitio</h2>
        <p data-id="element-668" data-mp="l74hv6pzck79">
          Este Sitio es informativo y está diseñado para facilitar solicitudes
          de consulta. La información presentada no constituye asesoramiento
          médico, diagnóstico ni tratamiento, y no establece una relación
          médico-paciente.
        </p>

        <h2 data-id="element-669" data-mp="2s06wn83fozpt">3. Solicitud de consulta</h2>
        <p data-id="element-670" data-mp="239cttxr4wbsf">
          Completar una solicitud de consulta no garantiza un procedimiento,
          resultado, cita ni candidatura. Cada caso se evalúa individualmente
          por el equipo médico para determinar su idoneidad y un plan
          personalizado.
        </p>

        <h2 data-id="element-671" data-mp="1thguykh84hn5">4. Programa de mensajes SMS</h2>
        <p data-id="element-672" data-mp="1pihqt23bgowr">
          Al proporcionar su consentimiento para mensajes de texto, acepta
          recibir mensajes de Lipolaser Los Angeles LLC relacionados con
          recordatorios
          de citas, actualizaciones de cuenta y ofertas promocionales. La
          frecuencia de los mensajes puede variar según su interacción con
          nosotros.
        </p>
        <p data-id="element-673" data-mp="2d9dfvrge160b">
          Pueden aplicarse tarifas de mensajes y datos. El consentimiento para
          recibir mensajes SMS no es una condición para comprar servicios.
        </p>

        <h2 data-id="element-674" data-mp="11tosiyz824yz">5. Instrucciones para cancelar mensajes</h2>
        <p data-id="element-675" data-mp="wt13ujygu07x">
          Puede cancelar los mensajes SMS en cualquier momento enviando
          <strong data-id="element-676" data-mp="yapqalq8v2qd"> STOP</strong>. Recibirá un mensaje de confirmación y no se
          enviarán más mensajes, salvo que vuelva a otorgar su consentimiento.
        </p>

        <h2 data-id="element-677" data-mp="137gddt0guyla">6. Soporte de mensajes</h2>
        <p data-id="element-678" data-mp="pab2nfpt5bjp">
          Para obtener ayuda, envíe <strong data-id="element-679" data-mp="p989t28xcz15">HELP</strong> por mensaje de texto o
          escríbanos a{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-680" data-mp="tabnbi3i2iz7">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-681" data-mp="fi59w3rqeq3g">7. Disponibilidad y responsabilidad de carriers</h2>
        <p data-id="element-682" data-mp="kbgjgcnxhkz2">
          Los carriers no son responsables por mensajes retrasados o no
          entregados. La entrega de mensajes depende de la disponibilidad de la
          red inalámbrica, el proveedor de servicios y otros factores fuera de
          nuestro control.
        </p>

        <h2 data-id="element-683" data-mp="3srjg7ndi5p8m">8. Restricción de edad</h2>
        <p data-id="element-684" data-mp="3ssl4itjj488a">
          Debe tener al menos 18 años de edad para otorgar consentimiento y
          recibir mensajes SMS de Lipolaser Los Angeles LLC.
        </p>

        <h2 data-id="element-685" data-mp="3e4uj1s6q3o5e">9. Política de Privacidad</h2>
        <p data-id="element-686" data-mp="3e5vwu4f4ioqt">
          Para conocer cómo recopilamos, utilizamos y protegemos su información,
          revise nuestra <Link to="/privacy" data-id="element-687" data-mp="3971et4ozd47r">Política de Privacidad</Link>.
        </p>

        <h2 data-id="element-688" data-mp="3n60z605gmwy4">10. Resultados individuales</h2>
        <p data-id="element-689" data-mp="3j34d1zgpoipf">
          Los resultados estéticos varían entre pacientes según factores como
          anatomía individual, estilo de vida, edad, salud general y
          cumplimiento del plan de recuperación. No garantizamos resultados
          específicos.
        </p>

        <h2 data-id="element-690" data-mp="3s1gdet7dquv2">11. Propiedad intelectual</h2>
        <p data-id="element-691" data-mp="ankrznq726lg">
          Todo el contenido del Sitio, incluidos textos, imágenes, logotipos y
          diseño, es propiedad de Lipolaser Los Angeles LLC o de sus respectivos
          propietarios y está protegido por leyes aplicables. Se prohíbe su
          reproducción sin autorización por escrito.
        </p>

        <h2 data-id="element-692" data-mp="eppf03m504z4">12. Imágenes y contenido de pacientes</h2>
        <p data-id="element-693" data-mp="emtkyqdeu0fy">
          Cuando se utilicen imágenes de pacientes, estas se comparten con el
          consentimiento correspondiente. Los resultados individuales pueden
          variar y las imágenes no garantizan resultados futuros.
        </p>

        <h2 data-id="element-694" data-mp="2ivqxzkpmw6xo">13. Limitación de responsabilidad</h2>
        <p data-id="element-695" data-mp="2ix22jmqwlipu">
          En la medida permitida por la ley, Lipolaser Los Angeles LLC no será
          responsable por daños directos, indirectos, incidentales o
          consecuentes derivados del uso o la imposibilidad de uso de este
          Sitio. El Sitio se proporciona "tal cual" sin garantías de ningún
          tipo.
        </p>

        <h2 data-id="element-696" data-mp="1z6fdcyb4dqg5">14. Enlaces externos</h2>
        <p data-id="element-697" data-mp="1z5dsy387rrlr">
          El Sitio puede incluir enlaces a sitios externos. No somos
          responsables de su contenido, disponibilidad ni prácticas de
          privacidad.
        </p>

        <h2 data-id="element-698" data-mp="3alc5ih2lovrq">15. Modificaciones</h2>
        <p data-id="element-699" data-mp="3fkykauy2uk2n">
          Podemos modificar estos Términos de Servicio en cualquier momento. Los
          cambios se publicarán en esta página y entrarán en vigor al
          publicarse.
        </p>

        <h2 data-id="element-700" data-mp="3pqq5vtokbj07">16. Ley aplicable</h2>
        <p data-id="element-701" data-mp="3kpivrnyy67qd">
          Estos términos se rigen por las leyes del Estado de California,
          Estados Unidos. Cualquier disputa se resolverá en los tribunales
          competentes del Condado de Los Ángeles, California.
        </p>

        <h2 data-id="element-702" data-mp="3bx8ifxsr9m4w">17. Contacto</h2>
        <p data-id="element-703" data-mp="36ye1z2i9g9ny">
          Para preguntas sobre estos Términos de Servicio o el programa de
          mensajes SMS, contáctenos mediante la información publicada en este
          Sitio.
        </p>
      </> : <>
        <h1 data-id="element-704" data-mp="2wzojp8mgcn76">Terms of Service</h1>
        <p className="muted" data-id="element-705" data-mp="2x0zpfdzgk50x">Last updated: July 11, 2026</p>

        <h2 data-id="element-706" data-mp="2sz4mk51vpjl1">1. Acceptance of terms</h2>
        <p data-id="element-707" data-mp="2t07ca9ngtfzd">
          By accessing and using this Site, you agree to these Terms of Service.
          If you do not agree, please do not use the Site.
        </p>

        <h2 data-id="element-708" data-mp="r6q9pke6z5bh">2. Nature of the site</h2>
        <p data-id="element-709" data-mp="r7ri1h3tpdpi">
          This Site is informational and designed to facilitate consultation
          requests. Information presented does not constitute medical advice,
          diagnosis, or treatment and does not establish a physician-patient
          relationship.
        </p>

        <h2 data-id="element-710" data-mp="2bqbvvalb5z38">3. Consultation requests</h2>
        <p data-id="element-711" data-mp="2bnh8ba6zzy5l">
          Completing a consultation request does not guarantee a procedure,
          result, appointment, or candidacy. Each case is evaluated individually
          by the medical team to determine suitability and a personalized plan.
        </p>

        <h2 data-id="element-712" data-mp="38e9rigp8a6bl">4. SMS program description</h2>
        <p data-id="element-713" data-mp="38d7087nzu1v5">
          By opting in to text messages, you agree to receive messages from
          Lipolaser Los Angeles LLC related to appointment reminders, account
          updates,
          and promotional offers. Message frequency may vary based on your
          interaction with us.
        </p>
        <p data-id="element-714" data-mp="1nzpwe7pddn4u">
          Message and data rates may apply. Consent to receive SMS messages is
          not a condition of purchasing services.
        </p>

        <h2 data-id="element-715" data-mp="1fhe3szqbavow">5. Opt-out instructions</h2>
        <p data-id="element-716" data-mp="1fkjx6r5z4jqf">
          You may opt out of receiving SMS messages at any time by texting
          <strong data-id="element-717" data-mp="1bj6o887l40fa"> STOP</strong>. You will receive a confirmation message, and
          no further messages will be sent unless you opt in again.
        </p>

        <h2 data-id="element-718" data-mp="1kittx67cjse5">6. Support contact</h2>
        <p data-id="element-719" data-mp="1kfpgdi7zrkat">
          For help, text <strong data-id="element-720" data-mp="wry4gfqd59a2">HELP</strong> or email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-721" data-mp="wszh2on123tw">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>

        <h2 data-id="element-722" data-mp="rra5n7vw7o5a">7. Carrier availability and liability</h2>
        <p data-id="element-723" data-mp="16ispxhvsc4ug">
          Carriers are not liable for delayed or undelivered messages. Message
          delivery depends on wireless network availability, service providers,
          and other factors outside our control.
        </p>

        <h2 data-id="element-724" data-mp="dzn8z6y1gdlz">8. Age restriction</h2>
        <p data-id="element-725" data-mp="93566cm9qpca">
          You must be 18 years of age or older to provide consent and receive
          SMS messages from Lipolaser Los Angeles LLC.
        </p>

        <h2 data-id="element-726" data-mp="3jqsslrmh57m9">9. Privacy Policy</h2>
        <p data-id="element-727" data-mp="3onj9gh63s78q">
          For more information about how we collect, use, and protect your
          information, please review our{' '}
          <Link to="/privacy" data-id="element-728" data-mp="3tm2u8e8ynczi">Privacy Policy</Link>.
        </p>

        <h2 data-id="element-729" data-mp="2gb2xbjg5ub4">10. Individual results</h2>
        <p data-id="element-730" data-mp="2hckzzyvrh2c">
          Aesthetic results vary between patients based on factors such as
          individual anatomy, lifestyle, age, general health, and adherence to a
          recovery plan. We do not guarantee specific results.
        </p>

        <h2 data-id="element-731" data-mp="g7zglj9cgqu7">11. Intellectual property</h2>
        <p data-id="element-732" data-mp="g90tlt9x7nek">
          All Site content, including text, images, logos, and design, is the
          property of Lipolaser Los Angeles LLC or its respective owners and is
          protected by applicable law. Reproduction without written
          authorization is prohibited.
        </p>

        <h2 data-id="element-733" data-mp="u6z8czs5llul">12. Patient images and content</h2>
        <p data-id="element-734" data-mp="u5o3ewmz281w">
          When patient images are used, they are shared with the applicable
          consent. Individual results may vary, and images do not guarantee
          future results.
        </p>

        <h2 data-id="element-735" data-mp="2aqajv00j9115">13. Limitation of liability</h2>
        <p data-id="element-736" data-mp="25obj7xw6gi7w">
          To the extent permitted by law, Lipolaser Los Angeles LLC is not
          liable for
          direct, indirect, incidental, or consequential damages arising from
          use of, or inability to use, this Site. The Site is provided "as is"
          without warranties of any kind.
        </p>

        <h2 data-id="element-737" data-mp="2tg0dvkwh1is0">14. External links</h2>
        <p data-id="element-738" data-mp="2th1r9w0ymhcw">
          This Site may include links to external websites. We are not
          responsible for their content, availability, or privacy practices.
        </p>

        <h2 data-id="element-739" data-mp="2joctg3yc1201">15. Modifications</h2>
        <p data-id="element-740" data-mp="3h49wkdye1qex">
          We may modify these Terms of Service at any time. Changes will be
          posted on this page and become effective upon posting.
        </p>

        <h2 data-id="element-741" data-mp="3cbyzrjyy2kql">16. Governing law</h2>
        <p data-id="element-742" data-mp="26usc8xjm2z9d">
          These terms are governed by the laws of the State of California, USA.
          Any dispute shall be resolved in the competent courts of Los Angeles
          County, California.
        </p>

        <h2 data-id="element-743" data-mp="2gsondpcjtu7h">17. Contact</h2>
        <p data-id="element-744" data-mp="2gtzlp9n869r7">
          For questions about these Terms of Service or the SMS messaging
          program, please email{' '}
          <a href="mailto:hello@lipolaserbeverlyhills.com" data-id="element-745" data-mp="2bsk1tkwsa9ae">
            hello@lipolaserbeverlyhills.com
          </a>
          .
        </p>
      </>;
  return <LegalLayout data-id="element-746" data-mp="2kvbh5vss5p7b">{content}</LegalLayout>;
}
function LegalLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <main className="min-h-screen bg-brand-cream" data-id="element-747" data-mp="2zi4n4agetimu">
      <header className="border-b border-brand-stone/50 py-6" data-id="element-748" data-mp="2ukcufe7xxshl">
        <div className="container mx-auto px-6 flex items-center justify-between" data-id="element-749" data-mp="2ul4scvp0g2b1">
          <Link to="/" className="flex items-baseline gap-1.5" data-id="element-750" data-mp="38kxh4lgz88gd">
            <span className="text-2xl font-serif font-normal text-brand-dark" data-id="element-751" data-mp="34j2ftgz1pv2l">
              Lipo Laser
            </span>
            <span className="text-[10px] font-medium tracking-[0.2em] uppercase text-brand-gold" data-id="element-752" data-mp="3n7w689sd2qrx">
              Beverly Hills
            </span>
          </Link>
          <LanguageToggle data-id="element-753" data-mp="3e64zd1m34dwh" />
        </div>
      </header>

      <article className="container mx-auto px-6 py-20 max-w-3xl legal-content" data-id="element-754" data-mp="3e5mszc5pkjau">
        {children}
        <div className="mt-16 pt-8 border-t border-brand-stone/50" data-id="element-755" data-mp="3j3odm1is8qof">
          <Link to="/" className="text-[11px] font-medium tracking-widest uppercase text-brand-dark/60 hover:text-brand-dark transition-colors" data-id="element-756" data-mp="34g38k22ckhdv">
            ← Home
          </Link>
        </div>
      </article>

      <style data-id="element-757" data-mp="2vdkadv9iasxy">{`
        .legal-content h1 {
          font-family: 'Playfair Display', serif;
          font-weight: 300;
          font-size: 3rem;
          color: #1B1714;
          letter-spacing: -0.02em;
          margin-bottom: 0.5rem;
        }
        .legal-content h2 {
          font-family: 'Playfair Display', serif;
          font-weight: 400;
          font-size: 1.5rem;
          color: #1B1714;
          margin-top: 2.5rem;
          margin-bottom: 0.75rem;
        }
        .legal-content p, .legal-content li {
          color: rgba(27, 23, 20, 0.75);
          line-height: 1.7;
          font-weight: 300;
          margin-bottom: 0.75rem;
        }
        .legal-content ul {
          list-style: none;
          padding-left: 1rem;
        }
        .legal-content li {
          padding-left: 1.5rem;
          position: relative;
        }
        .legal-content li::before {
          content: '·';
          color: #C9A961;
          position: absolute;
          left: 0;
          font-weight: 700;
        }
        .legal-content a {
          color: #C97B63;
          text-decoration: underline;
          text-underline-offset: 3px;
        }
        .legal-content a:hover {
          color: #1B1714;
        }
        .legal-content .muted {
          color: rgba(27, 23, 20, 0.4);
          font-size: 0.875rem;
          font-weight: 500;
          letter-spacing: 0.05em;
          margin-bottom: 3rem;
        }
        .legal-content strong {
          color: #1B1714;
          font-weight: 500;
        }
      `}</style>
    </main>;
}